"use client"
import { SectionHeadingTitle } from "@/components/SectionTitle";
import { useHeader } from "@/hooks/headerContext";
import { useTranslation } from "@/hooks/translationContext"
import ChatBubbleLeftIcon from "@heroicons/react/24/solid/ChatBubbleLeftIcon";

export default function ListpageCommentHeader() {
    const { t } = useTranslation();
    const { service, district } = useHeader();

    return (
        <SectionHeadingTitle
            title={t("listpage-commentSection-title", {
                defaultValue: "Yorum Yap/Soru Sor",
                service: service?.title,
                district: district?.title,
            })}
            icon={null}
            showRedBar
        />
    )
}